<template>
  <video-base :id="String(id)" category="動画教材" routerName="Home" />
</template>

<script>
import VideoBase from "@/components/VideoBase";
export default {
  components: {
    VideoBase
  },
  props: ["id"]
};
</script>
